import * as React from 'react';
import type { SignupLabels } from '../../organisms/signup-form';
import { SignupForm } from '../../organisms/signup-form';
import { SignupStepEnum, useSignup } from './useSignup';
import { ResetPassword } from '../reset-password';
import type { BrandLogo } from '@components/molecules/brand-header';
import type { SelectEmailFormLabels } from '@components/organisms/choose-email-form';
import type { ResetPasswordLabels } from '@components/organisms/reset-password-form';

type Props = {
	labels: {
		signup: SignupLabels;
		chooseEmail: SelectEmailFormLabels;
		resetPassword: ResetPasswordLabels;
	};
	logo?: BrandLogo;
	tosLink: string;
	handleNavigateToLink: () => void;
	onSuccess: (data: unknown) => void;
	onSSOSuccess: () => void | Promise<void>;
};

export const Signup: React.FC<Props> = ({ labels, logo, tosLink, handleNavigateToLink, onSuccess, onSSOSuccess }) => {
	const { step, signupEmail, handleSignup } = useSignup({
		onSuccess,
	});

	const CurrentStep = React.useMemo(() => {
		switch (step) {
			case SignupStepEnum.SIGNUP:
				return (
					<SignupForm
						tosLink={tosLink}
						labels={labels.signup}
						logo={logo}
						onSubmit={handleSignup}
						handleNavigateToLink={handleNavigateToLink}
						onSSOSuccess={onSSOSuccess}
					/>
				);
			case SignupStepEnum.RESET_PASSWORD:
				return (
					<ResetPassword
						labels={{ chooseEmail: labels.chooseEmail, resetPassword: labels.resetPassword }}
						onPasswordReset={handleNavigateToLink}
						goBackToLogin={handleNavigateToLink}
						initialEmail={signupEmail}
						autoSend
					/>
				);
			default:
				return null;
		}
	}, [step, logo, handleNavigateToLink, handleSignup, onSSOSuccess, labels, tosLink, signupEmail]);

	return <div className="flex w-full flex-col justify-center">{CurrentStep}</div>;
};
